// extracted by mini-css-extract-plugin
export default {"modal":"Jxi7nC","text":"kzs81a","actions":"VCB2uB","button":"ggHK3W"};